module.exports = __webpack_public_path__ + "img/bringtogether.e8bfd2c0.png";